import { Check } from "lucide-react";
import { Section, TextArea, Choices } from "./Fields";
import { ECHEANCES, DECIDEURS, FORMATS, CONTACTS, MOMENTS } from "../../content";

export const StepTwo = ({ data, set, errors }) => (
  <>
    <Section num="4" title="Votre situation" testid="fiche-section-4">
      <TextArea name="situation" label="Quelle situation retient le plus votre attention en ce moment ?" value={data.situation} onChange={set} />
      <TextArea name="vision_6_mois" label="Dans six mois, à quoi ressemblerait votre organisation si cette situation était réglée ?" value={data.vision_6_mois} onChange={set} />
      <TextArea name="deja_en_place" label="Ce que vous avez déjà mis en place" value={data.deja_en_place} onChange={set} />
    </Section>
    <Section num="5" title="Votre horizon" testid="fiche-section-5">
      <Choices name="echeance" question="Échéance souhaitée" options={ECHEANCES} value={data.echeance} onChange={set} />
      <Choices name="decideurs" question="Qui participe à la décision ?" options={DECIDEURS} value={data.decideurs} onChange={set} multiple />
    </Section>
    <Section num="6" title="Le format qui vous conviendrait" testid="fiche-section-6">
      <Choices name="formats" options={FORMATS} value={data.formats} onChange={set} multiple />
    </Section>
    <Section num="7" title="Pour la suite" testid="fiche-section-7">
      <Choices name="contact_prefere" question="Je préfère être joint(e) par" options={CONTACTS} value={data.contact_prefere} onChange={set} />
      <Choices name="moment" question="Meilleur moment" options={MOMENTS} value={data.moment} onChange={set} />
      <div className="ob-field">
        <button
          type="button"
          role="checkbox"
          aria-checked={data.consentement}
          onClick={() => set("consentement", !data.consentement)}
          className={`ob-consent ${data.consentement ? "is-on" : ""}`}
          data-testid="fiche-consentement-checkbox"
        >
          <span className="ob-box">{data.consentement && <Check size={12} strokeWidth={3} />}</span>
          <span>J'accepte qu'Ombodhi communique avec moi au sujet de ma demande.</span>
        </button>
        {errors.consentement && <p className="ob-hint" data-testid="fiche-hint-consentement">{errors.consentement}</p>}
      </div>
    </Section>
  </>
);
